<template>
  <div class="checkout" v-if="Object.keys(this.booking_data).length">
    <!-- nel js c'è un router push a 'detail' se non trovo booking_data (es. se refresho la pagina checkout). questo ulteriore controllo è per evitare un undefined rischioso a template -->
    <b-container>
      <booking-engine size="sm" />
    </b-container>
    <b-container>
      <div v-if="!loading">
        <b-row>
          <b-col>
            <dates-title :flight_offer="selected_flight_offer" />
          </b-col>
        </b-row>
      </div>
      <loader v-else class="mt-4" :show_timing_slot="true" />
      <b-row>
        <b-col sm="12" md="7" lg="8" xl="9">
          <div v-if="!loading">
            <div v-if="!checkout_ok">
              <div class="checkout--panel" compact>
                <flight-pad-details :flight_offer="selected_flight_offer" collapsed />
              </div>
              <content-section
                v-for="additional_service in get_paid_additional_services(selected_flight_offer)"
                :key="additional_service.type"
                :title="
                  capitalize_string(transcode_additional_services(additional_service.type, 99))
                "
              >
                <template
                  v-if="
                    additional_service.type === 'CHECKED_BAGS' &&
                    Object.keys(flexible_bags).length > 0
                  "
                >
                  <div
                    v-for="(traveler, traveler_index) in Object.keys(flexible_bags)"
                    v-bind:key="_uid + traveler_index"
                    :set="
                      traveler_detail =
                        booking_data.flightCreateOrderBody.data.travelers[traveler_index]
                    "
                  >
                    <div
                      v-if="
                        has_chargeable_bags(
                          selected_flight_offer,
                          selected_flight_offer.travelerPricings[traveler_index].travelerId
                        )
                      "
                    >
                      <hr class="my-2" v-if="traveler_index !== 0" />
                      {{ traveler_detail.name.firstName }}
                      {{ traveler_detail.name.lastName }}
                      <div
                        v-for="(itinerary, itinerary_index) in Object.keys(flexible_bags[traveler])"
                        v-bind:key="_uid + itinerary_index"
                        :set="itd = selected_flight_offer.itineraries[itinerary_index]"
                      >
                        <div
                          v-for="(bag, bag_index) in Object.keys(
                            flexible_bags[traveler][itinerary]
                          )"
                          v-bind:key="_uid + bag_index"
                        >
                          <div
                            v-if="flexible_bags[traveler][itinerary][bag].added"
                            :set="bag = flexible_bags[traveler][itinerary][bag].bag"
                          >
                            <div class="ml-2">
                              <b
                                >{{ bag.quantity }}
                                {{ bag.quantity > 1 ? 'bagagli' : 'bagaglio' }}
                                <!--({{ bag.weight }}{{ bag.weightUnit }})--></b
                              >
                              <i>
                                ({{ itd.segments[0].departure.iataCode }}
                                {{
                                  dictionaries.locations[itd.segments[0].departure.iataCode].name
                                }}
                                -
                                {{ itd.segments[itd.segments.length - 1].arrival.iataCode }}
                                {{
                                  dictionaries.locations[
                                    itd.segments[itd.segments.length - 1].arrival.iataCode
                                  ].name
                                }})
                              </i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else-if="additional_service.type === 'SEATS'">
                  <div
                    v-for="(seats, key) in seats_per_segment(
                      flight_offer,
                      booking_data.flightCreateOrderBody.data.travelers.map((e) => ({
                        ...e,
                        ...e.name,
                      }))
                    )"
                    :key="`${_uid}seats:${key}`"
                    class="d-flex gap-30px"
                  >
                    <div class="d-flex flex-column gap-5px">
                      <div>
                        {{ formatSegmentLabel(segmentsMap[key]) }}
                      </div>
                      <div class="d-flex flex-column gap-2px ml-2">
                        <span
                          v-for="seat in seats"
                          :key="`seat:${key}:${seat.chargeableSeatNumber}`"
                          v-b-popover.hover.top="seat.traveler_name || `P${seat.travelerId}`"
                        >
                          <span> {{ seat.traveler_name || `P${seat.travelerId}` }}: </span>
                          <span class="bold">
                            {{ seat.chargeableSeatNumber }}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </template>
              </content-section>
              <content-section title="I contatti a cui riverai le informazioni sul tuo volo">
                <template>
                  <div
                    v-for="(contact, index) in booking_data.flightCreateOrderBody.data.contacts"
                    v-bind:key="_uid + index"
                  >
                    <div class="d-block mb-1">
                      <span v-html="svg_traveler()" />
                      {{ contact.addresseeName.firstName }}
                      {{ contact.addresseeName.middleName }}
                      {{ contact.addresseeName.lastName }}
                    </div>
                    <div class="d-block mb-1" style="margin-left: 4px">
                      <span v-html="svg_mail(18)" />
                      {{ contact.emailAddress }}
                    </div>
                    <div class="d-block mb-1">
                      <span v-html="svg_phone()" />
                      +{{ contact.phones[0].countryCallingCode }}
                      {{ contact.phones[0].number }}
                    </div>
                    <hr
                      v-if="index < booking_data.flightCreateOrderBody.data.contacts.length - 1"
                    />
                  </div>
                </template>
              </content-section>
              <content-section
                title="Elenco dei passeggeri"
                description="Verifica che nomi e date di nascita siano corrispondenti a
                  quelli riportati nel documento di identità con cui verrà fatto
                  l'imbarco"
              >
                <template>
                  <div
                    v-for="(traveler, index) in booking_data.flightCreateOrderBody.data.travelers"
                    v-bind:key="_uid + index"
                  >
                    <div class="d-flex gap-5px align-items-center mb-1">
                      <span v-html="svg_traveler()" />
                      <span>
                        {{ traveler.name.firstName }}
                        {{ traveler.name.middleName }}
                        {{ traveler.name.lastName }}
                      </span>
                      <span style="font-size: 30px; line-height: 0"> &middot; </span>
                      <span>{{ reverse_date(traveler.dateOfBirth) }}</span>
                    </div>
                  </div>
                </template>
              </content-section>
            </div>
            <div v-else class="checkout--panel" compact>
              <p v-if="checkout_msg">
                <b-alert variant="success" v-html="checkout_msg" show />
              </p>
              <!--<p>
                                <b>codice di conferma</b>: {{ checkout_confirmcode }}
                            </p>-->
            </div>
          </div>
        </b-col>
        <b-col m="12" md="5" lg="4" xl="3">
          <div class="checkout--panel pt-0" compact>
            <sidebar-resume :flight_offers="[selected_flight_offer]" />
          </div>
          <div
            v-if="loading"
            class="checkout--panel text-center"
            :otp-wrap="'otp--' + otp_check"
            compact
          >
            <p v-if="purchasing">
              Prenotazione in corso... non abbandonare o ricaricare la pagina!
            </p>
            <b-spinner />
          </div>

          <div v-if="!loading" class="checkout--panel" :otp-wrap="'otp--' + otp_check" compact>
            <h3 class="h6 bold mb-3 pt-2">Completa la prenotazione</h3>
            <validation-observer v-slot="{ invalid }" ref="checkout-validation">
              <div class="sidebar-checkout--fields">
                <div v-if="!allowCustomBeneficiary">
                  <div class="form-group">
                    <label>Beneficiario</label>
                    <b-form-select
                      ref="checkoutBeneficiaries"
                      :required="true"
                      v-model="beneficiaryId"
                      :options="beneficiaries"
                      v-on:change="change_item(beneficiaryId)"
                    ></b-form-select>
                  </div>
                </div>
                <div v-else>
                  <validation-provider
                    rules="required|alpha_spaces|min:2"
                    name="firstname"
                    v-slot="{ errors }"
                  >
                    <div class="form-group">
                      <label>Nome *</label>
                      <b-form-input
                        v-model="firstname"
                        placeholder="Nome"
                        type="text"
                      ></b-form-input>
                      <span class="vee--errors">{{ errors[0] }}</span>
                    </div>
                  </validation-provider>
                  <validation-provider
                    rules="required|alpha_spaces|min:2"
                    name="lastname"
                    v-slot="{ errors }"
                  >
                    <div class="form-group">
                      <label>Cognome *</label>
                      <b-form-input
                        v-model="lastname"
                        placeholder="Cognome"
                        type="text"
                      ></b-form-input>
                      <span class="vee--errors">{{ errors[0] }}</span>
                    </div>
                  </validation-provider>
                </div>

                <hr />
                <validation-provider
                  :rules="{ required: { allowFalse: false } }"
                  name="privacy"
                  v-slot="{ errors }"
                >
                  <div class="privacy-box">
                    <b-form-checkbox v-model="privacy" />
                    <label for="checkbox-privacy" class="checkbox-label">
                      <router-link :to="{ name: 'terms' }" target="_blank" class="nounderline">
                        <span> Ho preso visione delle condizioni d'uso e le accetto </span>
                      </router-link>
                    </label>
                  </div>
                  <span class="vee--errors">{{ errors[0] }}</span>
                </validation-provider>

                <validation-provider
                  :rules="{ required: { allowFalse: false } }"
                  name="gdpr"
                  v-slot="{ errors }"
                >
                  <div class="privacy-box">
                    <b-form-checkbox v-model="gdpr" />
                    <label for="checkbox-gdpr" class="checkbox-label">
                      <p>
                        <a :href="site.urlPrivacy" target="_blank">
                          Ho preso visione delle condizioni di trattamento dei dati e le accetto
                        </a>
                      </p>
                    </label>
                  </div>
                  <span class="vee--errors">{{ errors[0] }}</span>
                </validation-provider>

                <validation-provider
                  v-if="disclaimer_checkout.copy !== ''"
                  :rules="{ required: { allowFalse: false } }"
                  name="disclaimer_checkout"
                  v-slot="{ errors }"
                >
                  <div class="privacy-box">
                    <b-form-checkbox v-model="disclaimer_checkout.value" />
                    <label for="checkbox-disclaimer_checkout" class="checkbox-label">
                      <p>{{ disclaimer_checkout.copy }}</p>
                    </label>
                  </div>
                  <span class="vee--errors">{{ errors[0] }}</span>
                </validation-provider>
              </div>
              <div v-if="!checkout_ok" class="sidebar">
                <b-spinner v-if="loading" variant="primary" />
                <div v-else class="sidebar--blocks">
                  <!--
                                        il v-if sostituisce il comportamento di mixinIsWelfare:
                                        <SidebarDc v-else-if="!mixinIsWelfare() && this.$config.integration.integration != 'jointly'" v-on:sidebar-order-confirmed="sidebarOrderConfirmed"/>
                                        TODO: integration.integration != 'jointly' può essere rimossa
                                    -->
                  <div compact v-if="show_discount_codes">
                    <hr class="mt-0" />
                    <discount-codes
                      :live_price="booking_data.live_price"
                      @discount-codes-update="(value) => handle_discount_code_update(value)"
                    />
                  </div>

                  <div>
                    <hr />
                    <payments :live_price="booking_data.live_price" :payments="all_payments" />
                  </div>

                  <!--<div class="panel mb-4" compact>-->
                  <div v-if="credit_card_amount > 0">
                    <hr />
                    <stripe
                      :amount="credit_card_amount"
                      :copy_button="'Continua'"
                      @stripe-init="
                        () => {
                          // application-specific actions
                          booking_data.payments.cc = {};
                          stripe_completed = false;
                        }
                      "
                      @stripe-change="
                        (e) => {
                          // application-specific actions
                          // no further actions required
                        }
                      "
                      @stripe-confirm="
                        (e) => {
                          // application-specific actions
                          if (e.error) {
                            stripe_completed = false;
                            window.eventBus.$emit('got_modal_notification', {
                              msg: e.message,
                              status: e.status,
                              callback: function () {},
                            });
                            return;
                          }
                          booking_data.payments.cc.paymentIntentId = e.paymentIntentId;
                          booking_data.payments.cc.nameSurname = e.name;
                          stripe_completed = true;
                          vm.$nextTick(() => {
                            // automatizzo eventuali altre azioni quando il percorso stripe è completato usando un metodo del componente interessato
                            // nextTick() attende l'aggiornamento del DOM, altrimenti non trovo le $refs aggiornate (<otp /> potrebbe non essere ancora montato nel dom)
                            if (show_otp) {
                              vm.$refs.otp.trigger();
                            } else {
                              vm.$refs.btn_checkout.trigger();
                            }
                          });
                        }
                      "
                    />
                  </div>

                  <div v-if="otp_required" v-show="show_otp">
                    <!-- evito che venga montato/smontato al cambio dell'importo della carta di credito -->
                    <hr />
                    <otp
                      :button_size="'md'"
                      :button_variant="'tertiary'"
                      ref="otp"
                      @otp-check="
                        (value) => {
                          otp_check = value;
                        }
                      "
                      @otp-purchase="
                        () => {
                          vm.$nextTick(() => {
                            vm.$refs.btn_checkout.trigger();
                          });
                        }
                      "
                      @otp-event="
                        (event) => {
                          custom_event('otp', event);
                        }
                      "
                      :disabled="invalid || email !== email_confirm"
                      :copy_button="'Continua'"
                    />
                  </div>

                  <div v-if="show_checkout_button">
                    <hr />
                    <btn-checkout
                      ref="btn_checkout"
                      @handle_data="purchase()"
                      :conditions="
                        invalid ||
                        email !== email_confirm ||
                        !get_availability(get_markup(flight_offer).mu_price).affordable
                      "
                      :copy="'Prenota'"
                      id="btn-checkout-sidebar"
                    />
                  </div>
                </div>
                <!-- TODO creare custom rule per validare la conferma della mail -->
              </div>
              <div v-if="checkout_ok && checkout_msg">
                <p>
                  <b-alert variant="success" v-html="checkout_msg" show />
                </p>
              </div>
            </validation-observer>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue';
import { subtract, sum, number, larger, round, format, smaller } from 'mathjs';
import { checkout, get_beneficiaries } from '@/api';
import {
  reverse_date,
  parse_flight_offers_date,
  custom_event,
  get_availability,
  parse_flight_offer_for_ecommerce_item,
  formatSegmentLabel,
  capitalize,
} from '@/utilities';
import {
  get_flight_offer_dates,
  has_chargeable_bags,
  get_markup,
  get_paid_additional_services,
  transcode_additional_services,
  seats_per_segment,
} from '@/flight-offer';
import { calendar } from '@/components/svg/flight';
import { chevron_left } from '@/components/svg/chevrons';
import { cellphone, letter } from '@/components/svg/common';
import { traveler } from '@/components/svg/user';
import BookingEngine from '@/components/blocks/booking-engine';
import FlightPadDetails from '@/components/blocks/flight-pad/flight-pad-details/flight-pad-details';
import Otp from '@/components/blocks/otp';
import DiscountCodes from '@/components/blocks/discount-codes';
import Payments from '@/components/blocks/payments';
import BtnCheckout from '@/components/atoms/btn-checkout';
import Stripe from '@/components/blocks/stripe';
import Loader from '@/components/blocks/loader';
import SidebarResume from '@/components/blocks/sidebar/sidebar-resume';
import ContentSection from '@/components/blocks/wrappers/content-section.vue';
import { getSegmentsFromFlightOffers } from '../../utilities/seat-map';
import DatesTitle from '@/components/blocks/dates-title.vue';

export default {
  name: 'checkout',
  components: {
    'sidebar-resume': SidebarResume,
    'booking-engine': BookingEngine,
    'flight-pad-details': FlightPadDetails,
    'content-section': ContentSection,
    otp: Otp,
    'discount-codes': DiscountCodes,
    payments: Payments,
    'btn-checkout': BtnCheckout,
    stripe: Stripe,
    loader: Loader,
    'dates-title': DatesTitle,
  },
  props: {},
  data() {
    return {
      segmentsMap: {},
      svg_mail: letter,
      svg_phone: cellphone,
      svg_traveler: traveler,
      vm: this,
      loading: true,
      purchasing: false,
      integration: Vue.prototype.$config.integration,
      site: Vue.prototype.$config.site,
      firstname:
        Vue.prototype.$config.integration && Vue.prototype.$config.integration.firstname
          ? Vue.prototype.$config.integration.firstname
          : '',
      lastname:
        Vue.prototype.$config.integration && Vue.prototype.$config.integration.lastname
          ? Vue.prototype.$config.integration.lastname
          : '',
      fiscal_code:
        Vue.prototype.$config.integration && Vue.prototype.$config.integration.fiscalCode
          ? Vue.prototype.$config.integration.fiscalCode
          : '',
      phone: process.env.VUE_APP_MODE == 'development' ? '39312345678' : '',
      email:
        Vue.prototype.$config.integration && Vue.prototype.$config.integration.email
          ? Vue.prototype.$config.integration.email
          : '',
      email_confirm:
        Vue.prototype.$config.integration && Vue.prototype.$config.integration.email
          ? Vue.prototype.$config.integration.email
          : '',
      gdpr: process.env.VUE_APP_MODE == 'development' ? true : false,
      privacy: process.env.VUE_APP_MODE == 'development' ? true : false,
      disclaimer_checkout: {
        value: process.env.VUE_APP_MODE == 'development' ? true : false,
        copy: Vue.prototype.$config.guiSettings.disclaimerCheckout,
      },
      checkout_ok: false,
      checkout_msg: '',
      checkout_confirmcode: '',
      otp_check: false,
      otp_required:
        Vue.prototype.$config.integration && Vue.prototype.$config.integration.otpRequired
          ? Vue.prototype.$config.integration.otpRequired
          : false,
      beneficiaries: [],
      beneficiaryId: '',
      allowCustomBeneficiary: false,
      discount_codes_amount: 0,
      stripe_completed: false,
    };
  },
  computed: {
    show_chargeable_bags() {
      return Object.keys(this.flexible_bags).some((_, traveler_index) =>
        this.has_chargeable_bags(
          this.selected_flight_offer,
          this.selected_flight_offer.travelerPricings[traveler_index].travelerId
        )
      );
    },
    dictionaries() {
      return this.$store.state.liveflight.results.dictionaries;
    },
    availability() {
      return this.$store.state.availability;
    },
    all_payments() {
      let availability = this.availability > -1 ? this.availability : 0,
        welfare_to_use = smaller(number(this.booking_data.live_price), availability)
          ? number(this.booking_data.live_price)
          : this.availability;

      return [
        {
          name: 'Credito welfare',
          value: welfare_to_use,
          info: '',
        },
        {
          name: 'Buoni caricati',
          value: this.discount_codes_amount,
          info: '',
        },
        {
          name: 'Carta di credito',
          value: this.credit_card_amount,
          info: '',
        },
      ];
    },
    credit_card_amount() {
      // welfare==true => no carta di credito
      if (this.integration.welfare == true) return 0;
      let availability = larger(this.availability, 0) ? this.availability : 0;
      // pagamenti diversi dal credito welfare (per ora solo codici sconto)
      let total_other_payments = this.discount_codes_amount;
      // se (availability + altri pagamenti) coprono il live_price, non c'è da pagare niente con carta
      if (larger(sum(availability, total_other_payments), number(this.booking_data.live_price)))
        return 0;
      let residual = subtract(
        number(this.booking_data.live_price),
        sum(availability, total_other_payments)
      );
      return round(residual, 2);
    },
    selected_flight_offer() {
      return this.$store.state.liveflight.flight_offer;
    },
    bags: {
      get() {
        return this.$store.state.liveflight.bags;
      },
      set() {},
    },
    flexible_bags() {
      return this.$store.state.liveflight.flexible_bags;
    },
    booking_data: {
      get() {
        return this.$store.state.booking_data;
      },
      set(value) {
        this.$store.commit('booking_data', value);
      },
    },
    travelersDetails() {
      try {
        return this.booking_data.flightCreateOrderBody.data.travelers || [];
      } catch {
        // EMPTY
      }
      return [];
    },
    show_discount_codes() {
      let is_welfare = false;
      if (this.integration) is_welfare = this.integration.welfare;
      else is_welfare = true;
      return !is_welfare && this.integration.integration !== 'jointly';
    },
    show_otp() {
      // mostro otp se:
      // - è richiesto dal config e non è stato completato l'iter otp
      // - c'è un totale da caricare su carta di credito E la procedura stripe è completata
      // condizione originale rifattorizzata: v-if="otp_required && (otp_check == false) && ((credit_card_amount > 0 && stripe_completed) | credit_card_amount == 0)"
      let otp_required = this.otp_required,
        otp_completed = this.otp_check == false,
        credit_card_required = this.credit_card_amount > 0,
        credit_card_completed = credit_card_required && this.stripe_completed;

      return otp_required && otp_completed && credit_card_completed | !credit_card_required;
    },
    show_checkout_button() {
      //nascondo il pulsante di checkout se:

      // è richiesto l'otp ma non è ancora stato validato
      if (this.otp_required && !this.otp_check) return false;

      // serve integrare il pagamento con la carta ma ancora non si è completata la procedura di stripe
      if (this.credit_card_amount > 0 && !this.stripe_completed) return false;

      // pulsante mostrato: è comunque gestito lo stato :disabled direttamente a template
      return true;
    },
    flight_offer() {
      return this.$store.state.liveflight.flight_offer;
    },
    contact_details() {
      return this.$store.state.liveflight.contact_details || {};
    },
  },
  created() {
    this.checkout = checkout;
    this.chevron_left = chevron_left;
    this.get_flight_offer_dates = get_flight_offer_dates;
    this.has_chargeable_bags = has_chargeable_bags;
    this.calendar = calendar;
    this.reverse_date = reverse_date;
    this.parse_flight_offers_date = parse_flight_offers_date;
    this.custom_event = custom_event;
    this.get_availability = get_availability;
    this.get_markup = get_markup;

    // se non trovo booking data rimando al dettaglio
    if (!Object.keys(this.booking_data).length) {
      this.$router.replace('detail');
      return;
    }

    // per evitare undefined quando li popolo dinamicamente
    // TODO: l'ideale sarebbe che ciascun componente (es: <stripe />) esporti un suo local-store.js come state module agganciato dinamicamente allo store globale - da approfondire
    if (this.booking_data.payments == undefined) {
      this.booking_data.payments = {
        cc: {},
        welfare: {},
        discountCodes: {},
      };
    }

    this.ensure_contact_details();
  },
  mounted() {
    this.segmentsMap = getSegmentsFromFlightOffers([this.selected_flight_offer]);
    custom_event('initiateCheckout', this.selected_flight_offer.price.grandTotal);

    let item = parse_flight_offer_for_ecommerce_item(this.selected_flight_offer);

    custom_event({
      event: 'begin_checkout',
      ecommerce: {
        currency: 'EUR',
        items: [item],
        transaction_id: '',
        affiliation: '',
        value: item.price, // Sum of (price * quantity) for all items.
        tax: 0,
        shipping: 0,
        coupon: '',
      },
    });
    custom_event({
      event: 'add_to_cart',
      ecommerce: {
        currency: 'EUR',
        items: [item],
        transaction_id: '',
        affiliation: '',
        value: item.price, // Sum of (price * quantity) for all items.
        tax: 0,
        shipping: 0,
        coupon: '',
      },
    });
    get_beneficiaries()
      .then(
        (response) => {
          let data = response.data,
            bens = Object.values(data.beneficiaries);

          bens.forEach((ben) => {
            this.beneficiaries.push({
              value: ben.id,
              name: ben.name,
              surname: ben.surname,
              fiscalCode: ben.fiscalCode,
              email: ben.email,
              text: ben.name + ' ' + ben.surname,
            });
          });
          this.beneficiaryId = this.beneficiaries.length !== 0 ? this.beneficiaries[0].value : 0;
          this.allowCustomBeneficiary = data.allowCustomBeneficiary;
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      )
      .finally(() => {
        this.ensure_contact_details();
      });
  },
  methods: {
    get_paid_additional_services,
    transcode_additional_services,
    seats_per_segment,
    formatSegmentLabel,
    capitalize_string: capitalize,
    purchase() {
      let amount = number(this.booking_data.live_price);
      // caso dc/stripe (welfare==false): passano anche i totali (eventuali!) di codici sconto e stripe
      // aggiorno "amount" prima di metterlo in booking_data.payments.welfare.amount
      if (this.integration.welfare == false) {
        if (larger(this.discount_codes_amount, 0))
          amount = subtract(amount, this.discount_codes_amount);
        if (larger(this.credit_card_amount, 0)) amount = subtract(amount, this.credit_card_amount);
        this.booking_data.payments.cc.amount =
          typeof this.credit_card_amount == 'string'
            ? this.credit_card_amount
            : format(this.credit_card_amount);
        this.booking_data.payments.discountCodes = {};
        this.booking_data.payments.discountCodes.amount =
          typeof this.discount_codes_amount == 'string'
            ? this.discount_codes_amount
            : format(this.discount_codes_amount);
        this.booking_data.payments.discountCodes.codes = this.$store.state.discount_codes.map(
          (d) => {
            return {
              discountCode: d.discountCode,
              amount: typeof d.valueUsed == 'string' ? d.valueUsed : format(d.valueUsed),
              valueNominal:
                typeof d.valueNominal == 'string' ? d.valueNominal : format(d.valueNominal),
              valueResidual:
                typeof d.valueResidual == 'string' ? d.valueResidual : format(d.valueResidual),
              expirationDate: d.expirationDate,
            };
          }
        );
      }

      // booking_data.payments.welfare.amount passa in ogni caso, solo che:
      // caso base (welfare==true): amount coincide con il live_price
      // caso dc/stripe (welfare==false): l'amount è il live_price da cui ho sottratto (eventuali) codici sconto
      this.booking_data.payments.welfare.amount = format(round(amount, 2));
      const guests = {
        guestFirstName: this.firstname,
        guestLastName: this.lastname,
        guestFiscalCode: this.fiscal_code,
        guestEmail: this.email,
        guestEmailConf: this.email_confirm,
        guestPrivacy: this.privacy,
        beneficiaryId: !this.allowCustomBeneficiary ? this.beneficiaryId : 0,
      };
      if (this.phone && this.phone.length > 0) {
        guests.guestPhone = this.phone;
      }
      this.$store.commit('guests', guests);

      this.loading = true;
      this.purchasing = true;

      this.checkout().then(
        (success) => {
          success;
          window.scrollTo(0, 0);
          this.checkout_msg = success.data.msg;
          this.loading = false;
          this.purchasing = false;
          this.checkout_ok = true;

          if (success.status == 202) return; // asyncPayment, see checkout api / modal_notification

          if (!success.data.errors) {
            custom_event('confirmedCheckout', this.selected_flight_offer.price.grandTotal);

            let item = parse_flight_offer_for_ecommerce_item(this.selected_flight_offer);
            custom_event({
              event: 'purchase',
              ecommerce: {
                currency: 'EUR',
                items: [item],
                transaction_id: success.data.confirmcode,
                affiliation: '',
                value: item.price, // Sum of (price * quantity) for all items.
                tax: 0,
                shipping: 0,
                coupon: '',
              },
            });
            if (success.data.updateAvailabilityTo)
              Vue.prototype.$config.integration.availability = success.data.updateAvailabilityTo;

            /*this.$router.push({
                                    name: 'confirm',
                                    params: {
                                      flight_voucher_id: success.data.flightVoucherId.toString(),
                                      confirm_code: success.data.confirmcode,
                                    }
                                  })*/

            // in attesa di avere un "refresh" per pannello utente/integration
            // navigo alla pagina di conferma così ricarica config e gli eventuali dc del login
            window.location.href =
              '/confirm/' +
              success.data.flightVoucherId.toString() +
              '/' +
              success.data.confirmcode;
          }
        },
        (error) => {
          error;
          this.loading = false;
          this.purchasing = false;
          custom_event('checkoutError');
        }
      );
    },
    change_item(id) {
      const ben = this.beneficiaries.find((beneficiary) => beneficiary.value === id);

      this.firstname = ben.name;
      this.lastname = ben.surname;
      this.fiscal_code = ben.fiscalCode;
    },
    ensure_contact_details() {
      // Get the data specified in the contact details
      if (this.contact_details.email) {
        this.email = this.contact_details.email;
        this.email_confirm = this.contact_details.email;
      }

      if (this.contact_details.phone && this.contact_details.phone.length > 0) {
        this.phone = this.contact_details.phone;
      } else {
        this.phone = undefined;
      }
    },
    handle_discount_code_update(evt) {
      this.discount_codes_amount = evt.discount_codes_amount;
    },
  },
};
</script>

<style lang="scss">
.checkout {
  &--panel {
    @extend .panel !optional;
    margin-bottom: 1rem !important;
  }
  .privacy-box {
    display: flex;
  }
  .btn-light {
    .chevron svg {
      width: 10px;
      height: auto;
      path {
        stroke: $cta;
      }
    }
  }
  /*
    .sidebar--blocks {
        &>div:last-child {
            margin-top:$grid-gutter-width;
            hr {
                display:none;
            }
        }
    }
    */
}
</style>
